<template>
  <div class="wire vpc d-flex account" :style="accountRightBorderStyle">
    <span class="line" />
    <div v-if="isLast" class="account-left-none-line" :style="leftLineStyle" />
    <div class="text-center">
      <tooltip v-if="tooltipShow">
        <template slot="title">
          {{ $t('cloudenv.text_12') }}
        </template>
        <template slot="content">
          <p>{{ $t('common.name') }}：{{ accountName }}</p>
          <p>{{ $t('system.cpu_count') }}：{{ account.cpu_count }}</p>
          <p>{{ $t('system.vcpu_count') }}：{{ account.vcpu_count }}</p>
          <p>{{ $t('system.mem_size') }}：{{ sizestr(account.mem_size, 'M', 1024) }}</p>
          <p>{{ $t('system.vmem_size') }}：{{ sizestr(account.vmem_size, 'M', 1024) }}</p>
          <p>{{ $t('dashboard.text_136') }}：{{ account.hosts.length }}</p>
          <p>{{ $t('cloudenv.text_72') }}：{{ account.server_count }}</p>
          <p>{{ $t('compute.passthrough_device_count') }}：{{ account.gpu_count }}</p>
          <p>{{ $t('system.gpu_used_count') }}：{{ account.gpu_used_count }}</p>
        </template>
      </tooltip>
      <icon type="res-cloudaccount" @click="handleClick" @mouseover="handleMouseover" @mouseout="handleMouseout" />
      <span class="name text-truncate" style="overflow: visible;"><div class="text">{{ accountName }}</div></span>
      <icon v-if="account.hosts && account.hosts.length && !hostVisible" class="expand-icon" type="expand" @click="handleClick" />
    </div>
    <span class="line" :style="hostVisible && account.hosts && account.hosts.length ? '' : 'border:none'" />
  </div>
</template>

<script>
import ResMixin from '@Network/sections/Topology/ResMixin'
import { sizestr } from '@/utils/utils'
import Tooltip from './Tooltip'

export default {
  name: 'ResAccount',
  components: {
    Tooltip,
  },
  mixins: [ResMixin],
  props: {
    dataSource: {
      type: Object,
      default () {
        return {}
      },
    },
    account: {
      type: Object,
      default () {
        return {}
      },
    },
    isLast: {
      type: Boolean,
      default: false,
    },
    hostVisible: Boolean,
  },
  data () {
    return {
      sizestr,
      tooltipShow: false,
    }
  },
  computed: {
    accountName () {
      return this.account.name
    },
    leftLineStyle () {
      const len = this.account.hosts.length * 2
      return `height:${120 * len + 20}px`
    },
    accountRightBorderStyle () {
      if (this.account.isChildrenShow && this.account.hosts.length) {
        return 'border-right:solid 2px #000'
      }
      return ''
    },
  },
  methods: {
    handleClick (e) {
      this.$set(this.account, 'isChildrenShow', !this.account.isChildrenShow)
    },
    handleMouseover () {
      this.tooltipShow = true
    },
    handleMouseout () {
      this.tooltipShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "@Network/sections/Topology/index.scss";
.wire {
  min-height: 120px!important;
  .line {
    width: 80px !important;
  }
}
.account {
  position: relative;
  .account-left-line {
    width: 10px;
    height: 200px;
    position: absolute;
    left: -5px;
    top: 2px;
    background: #fff;
  }
}
.expand-icon {
  position: absolute;
  left: 85px;
  top: 38px;
  width: 15px!important;
  height: 15px!important;
  border: none!important;
}
.account-left-none-line {
  width: 8px;
  height: 300px;
  position: absolute;
  left: -5px;
  top: 2px;
  background: #fff;
}
</style>
